import { Button, Form } from "rsuite";
import { useState, useEffect, useCallback } from "react";
import {
  AdminAddFormType,
  AdminAddFormSchema,
  AdminAddDefaultValues,
} from "../../models/forms/adminAddForm";
import { ApiAdmin } from "../../core/apis/admin";
import { AppRoutesUI } from "../../config/appRoutes";
import { showSuccessToast, showErrorToast } from "../generic/toast.component";
import { useNavigate, useLocation } from "react-router-dom";
import { ApiSchemaAdmin } from "../../models/api/apiSchemaAdmin";
import { EditForm } from "../generic/forms/editProfile/editProfileForm";
import { ApiAuth } from "../../core/apis";

export const EditAdmin = () => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const [data, setData] = useState<ApiSchemaAdmin>();
  const [formValue, setFormValue] = useState<AdminAddFormType>(
    AdminAddDefaultValues
  );
  const handleChange = useCallback(
    (data: any, _: any) =>
      setFormValue((prevFormData) => ({ ...prevFormData, ...data })),
    []
  );
  useEffect(() => {
    setIsLoading(true);
    if ((location.state as string) === null) {
      getProfileInfo();
    } else {
      getUserDetails();
    }
    setIsLoading(false);
  }, []);

  const getUserDetails = async () => {
    ApiAdmin.getAdminDataById(location.state as string).then((res) => {
      setData(res.Data);
      setFormValue({
        adminId: res.Data?.Id,
        email: res.Data?.Email,
        userName: res.Data?.UserName,
        password: "",
        confPassword: "",
        firstName: res.Data?.FirstName,
        lastName: res.Data?.LastName,
        companyName: res.Data?.CompanyName,
        address: res.Data?.Address,
        state: res.Data?.State,
        country: res.Data?.CountryName,
        countryId: res.Data?.CountryId,
      });
    });
  };

  const getProfileInfo = async () => {
    ApiAuth.getProfileInfo().then((res) => {
      setData(res.Data);
      setFormValue({
        adminId: res.Data?.Id,
        email: res.Data?.Email,
        userName: res.Data?.UserName,
        password: "",
        confPassword: "",
        firstName: res.Data?.FirstName,
        lastName: res.Data?.LastName,
        companyName: res.Data?.CompanyName,
        address: res.Data?.Address,
        state: res.Data?.State,
        country: res.Data?.CountryName,
      });
    });
  };

  const handleSave = async (checked: boolean) => {
    const adminId = location.state as string;
    if (!checked) return;
    setIsLoading(true);
    const hasAtLeastOneCapLetter =
      /[A-Z]/.test(formValue.password ?? "") &&
      /[A-Z]/.test(formValue.confPassword ?? "");
    const hasAtLeastOneNumber =
      /[0-9]/.test(formValue.password ?? "") &&
      /[0-9]/.test(formValue.confPassword ?? "");
    if (formValue.password !== formValue.confPassword) {
      showErrorToast("Passwords don't match!");
      setIsLoading(false);
      return;
    } else if (
      (formValue.password && formValue.password?.length < 8) ||
      (formValue.confPassword && formValue.confPassword?.length < 8) ||
      !hasAtLeastOneCapLetter ||
      !hasAtLeastOneNumber
    ) {
      showErrorToast(
        "Password must be at least 8 characters (at least 1 number and 1 capital letter)"
      );
      setIsLoading(false);
      return;
    } else {
      try {
        await ApiAdmin.updateAdmin(
          adminId,
          formValue.password || "",
          formValue.confPassword || "",
          formValue.firstName || "",
          formValue.lastName || "",
          formValue.companyName || "",
          formValue.address || "",
          formValue.state || "",
          formValue.countryId || ""
        );
        showSuccessToast("Admin Updated Successfully");
      } catch (error: any) {
        showErrorToast(error.response?.data?.Message || error.message);
      }
      navigate(AppRoutesUI.Admins.AdminList());
      setFormValue(AdminAddDefaultValues);
      setIsLoading(false);
    }
  };
  return (
    <div className="email-card">
      <Form
        formValue={formValue}
        onChange={handleChange}
        model={AdminAddFormSchema}
        onSubmit={handleSave}
        fluid
      >
        <EditForm country={formValue.countryId ? formValue.countryId : ""} />
        <div className="d-flex justify-content-end align-items-center">
          <Button
            size="sm"
            appearance="primary"
            className="m-2 me-3 form-buttons"
            type="submit"
            loading={isLoading}
          >
            Update
          </Button>
        </div>
      </Form>
    </div>
  );
};
